export default __webpack_public_path__ + "static/media/donate border.1e777502.png";